import { createSelector } from 'reselect';

import type { RootState } from '@/types/store/common';

export const getSortedGoals = createSelector(
  (state: RootState) => state.goals,
  goals => goals.slice().sort((a, b) => a.position - b.position)
);
